import { FunctionComponent } from 'react';
import { t } from '@/utils/i18n';
import { AppearanceSwitchProps } from '@/redux/modal/types';
import { ModalProps } from '@/components/common/ModalManager';
import { SwitchDialog } from '@/components/common/SwitchDialog';

export const AppearanceSwitchDialog: FunctionComponent<AppearanceSwitchProps & ModalProps> = ({
  cids,
  accept,
  dismiss,
}) => {
  return (
    <SwitchDialog
      cids={cids}
      hint={t('productInfoPanel.AppearanceChange.hint')}
      title={t('productInfoPanel.AppearanceChange.dialog.title')}
      acceptText={t('productInfoPanel.AppearanceChange.dialog.apply')}
      cancelText={t('productInfoPanel.AppearanceChange.dialog.cancel')}
      onAccept={accept}
      onCancel={dismiss}
    />
  );
};
